import React, { useEffect } from 'react';
import './Popup.css';

export type PopupType = 'success' | 'error' | 'info' | 'warning';

interface PopupProps {
  type: PopupType;
  title: string;
  message: string;
  onClose: () => void;
  duration?: number; // Auto-close after duration (ms), 0 = no auto-close
}

const Popup: React.FC<PopupProps> = ({
  type,
  title,
  message,
  onClose,
  duration = 2500
}) => {
  useEffect(() => {
    if (duration > 0) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);

      return () => clearTimeout(timer);
    }
  }, [duration, onClose]);

  const getIcon = () => {
    switch (type) {
      case 'success':
        return (
          <svg className="popup-icon-svg" width="80" height="80" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
            <path d="M7 12L10.5 15.5L17 9" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        );
      case 'error':
        return (
          <svg className="popup-icon-svg" width="80" height="80" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
            <path d="M15 9L9 15M9 9L15 15" stroke="currentColor" strokeWidth="3" strokeLinecap="round"/>
          </svg>
        );
      case 'warning':
        return (
          <svg className="popup-icon-svg" width="80" height="80" viewBox="0 0 24 24" fill="none">
            <path d="M12 2L2 20H22L12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M12 9V13" stroke="currentColor" strokeWidth="3" strokeLinecap="round"/>
            <circle cx="12" cy="16.5" r="1.2" fill="currentColor"/>
          </svg>
        );
      case 'info':
        return (
          <svg className="popup-icon-svg" width="80" height="80" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
            <path d="M12 16V11" stroke="currentColor" strokeWidth="3" strokeLinecap="round"/>
            <circle cx="12" cy="8" r="1.2" fill="currentColor"/>
          </svg>
        );
    }
  };

  return (
    <>
      {/* Backdrop */}
      <div className="popup-backdrop" onClick={onClose} />

      {/* Popup */}
      <div className={`popup popup-${type}`}>
        <div className="popup-icon">
          {getIcon()}
        </div>

        <h3 className="popup-title">{title}</h3>
        <p className="popup-message">{message}</p>

        <button className="popup-close-btn" onClick={onClose}>
          OK
        </button>
      </div>
    </>
  );
};

export default Popup;
